<template>
  <div>
    <PageAllow controller="Examines" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('Examine.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="examine_code"
                  v-model="options.examine_code"
                  @text="examineCodeKeyword = $event"
                  :label="$t('Examine.examineCodeKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="order_code"
                  v-model="options.order_code"
                  @text="orderCodeKeyword = $event"
                  :label="$t('Examine.orderCodeKeyword')"
                />
              </v-col>
              <!-- 商品 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherAccountMaterials v-model="materialSelected" returnId />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('Examine.status.title')"
                  :items="$consts.examine.status"
                />
              </v-col>
              <!--              <v-col-->
              <!--                cols="12"-->
              <!--                sm="6"-->
              <!--                md="4"-->
              <!--                v-if="accountSettings && accountSettings.abnormal_examine"-->
              <!--              >-->
              <!--                <SearcherStatus-->
              <!--                  v-model="options.abnormal_flgs"-->
              <!--                  :label="$t('Examine.abnormalFlgs.title')"-->
              <!--                  :items="$consts.examine.abnormal_flgs"-->
              <!--                />-->
              <!--              </v-col>-->
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="examines"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.examine_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
            </span>
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.examine_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.shop.shop_name="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{
                item.shop
                  ? item.shop.shop_name + "【" + item.shop.shop_code + "】"
                  : ""
              }}
            </span>
            <br />
            <a
              class="text-no-wrap caption"
              :href="'/#/orders/' + item.order_id"
              style="text-decoration: none"
            >
              {{ item.order_code }}
            </a>
          </template>
          <template v-slot:item.distribution_user_name="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.distribution_user_name }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.stock ? item.stock.name : "" }}
            </span>
          </template>
          <template v-slot:item.examine_flg="{ item }">
            <span v-if="item.examine_flg == 0" class="danger--text">
              {{ item.examine_flg | examineFlgsText }}
            </span>
            <span v-else-if="item.examine_flg == 1">
              {{ item.shop_user_name }}
            </span>
            <span v-else>{{ item.examine_flg | examineFlgsText }}</span>
          </template>
          <template v-slot:item.is_examined="{ item }">
            <v-chip
              small
              label
              :color="item.is_examined | examineStatusColor"
              :text-color="item.is_examined | examineStatusTextColor"
              >{{ item.is_examined | examineStatusText }}
            </v-chip>
          </template>
          <template v-slot:item.examine_time="{ item }">
            {{ item.examine_time | formatTime }}
          </template>
          <template v-slot:item.actions="{ item }">
            <ExamineActions
              :examine="item"
              showView
              :showExamine="item.actions.examine"
              :showAbnormal="item.actions.abnormal"
              :showReturn="item.return_flg ? true : false"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherAccountMaterials from "@/components/plugins/SearcherAccountMaterials";
import ExamineActions from "./plugins/Actions";
import Examines from "@/api/examines";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  examine_code: "",
  order_code: "",
  status: [0, 1],
  material_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherStatus,
    ExamineActions,
    SearcherAccountMaterials,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.orderManagement"),
        disabled: false,
        replace: true,
        href: "/orders",
      },
      {
        text: i18n.t("Nav.examines"),
        disabled: true,
        href: "/examines",
      },
    ],

    headers() {
      return [
        {
          text:
            i18n.t("Examine.Fields.examine_code") +
            " / " +
            i18n.t("Examine.Fields.created_time"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "examine_code",
        },
        {
          text:
            i18n.t("Examine.Fields.shop_name", [this.$consts.shopName()]) +
            " / " +
            i18n.t("Examine.Fields.order_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop.shop_name",
        },
        {
          text:
            i18n.t("Examine.Fields.distribute_line") +
            " / " +
            i18n.t("Examine.Fields.stock_name"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "distribution_user_name",
        },
        {
          text: i18n.t("Examine.Fields.examiner"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "examine_flg",
        },
        {
          text: i18n.t("Examine.Fields.examine_status"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "is_examined",
        },
        {
          text: i18n.t("Examine.Fields.examine_time"),
          align: "center",
          class: "text-no-wrap",
          width: "180",
          sortable: false,
          value: "examine_time",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountSettings", "stickTableCols"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    examineCodeKeyword: "",
    orderCodeKeyword: "",
    examines: [],
    options: JSON.parse(
      sessionStorage.getItem("examines-options")
        ? sessionStorage.getItem("examines-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    materialSelected: [],
  }),

  mounted() {
    this.$commonUtils.loadOptions("examines", ["materialSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
          if (
            typeof this.options.created_time_from != "undefined" &&
            typeof this.options.created_time_to != "undefined"
          )
            this.datetimeRage = [
              this.options.created_time_from,
              this.options.created_time_to,
            ];
        } else this.resetSearch();
        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "materialSelected":
              this.materialSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        examine_code: this.examineCodeKeyword,
        order_code: this.orderCodeKeyword,
      });
    },

    resetSearch() {
      this.materialSelected = [];
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.examine_code, this.$refs.order_code].forEach((k) => {
        if (k) k.clear();
      });
    },

    getExaminesFromAPI() {
      Examines.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.examines = response.data.examines;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    accountSettings: {
      immediate: true,
      handler() {
        this.getExaminesFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getExaminesFromAPI();
        sessionStorage.setItem(
          "examines-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "examines-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
  },
};
</script>